import {createContext, useState} from 'react';
import {useCookies} from 'react-cookie';

const TranslationContext = createContext(null)

const translationConfig = require('../Translation/translations_lang.json')
const DEFAULT_LANGUAGE = 'fr'

function resolveInitialLanguage(cookieLang) {
    if (cookieLang && translationConfig.available_language.includes(cookieLang)) {
        return cookieLang
    }
    const browserLang = (navigator.language || '').slice(0, 2).toLowerCase()
    if (translationConfig.available_language.includes(browserLang)) {
        return browserLang
    }
    return DEFAULT_LANGUAGE
}

function TranslationProvider({children}) {
    const [translationCache, setTranslationCache] = useState({})
    const [cookies, setCookie] = useCookies(['DASHBOARD_LANG'])
    const [currentLanguage, setCurrentLanguage] = useState(() => resolveInitialLanguage(cookies.DASHBOARD_LANG))

    /**
     * Change la langue active et la persiste dans un cookie.
     */
    const setLanguage = (lang) => {
        if (!translationConfig.available_language.includes(lang)) return
        setCurrentLanguage(lang)
        setCookie('DASHBOARD_LANG', lang, {path: '/', maxAge: 60 * 60 * 24 * 365})
    }

    /**
     * Translate
     * @param translationKey
     * @param context translation filename with extension (e.g. 'Sidebar.json')
     * @param variable
     */
    const translation = (translationKey, context, variable = []) => {
        let cache = translationCache
        const lang = currentLanguage.toUpperCase()

        if (
            !(lang in cache &&
                context in cache[lang])
        ) {
            cache = {...cache, [lang]: {...cache[lang]}}
            cache[lang][context] = require('../Translation/' + lang + '/' + context)
            setTranslationCache(cache)
        }

        if (
            lang in cache &&
            context in cache[lang] &&
            translationKey in cache[lang][context]
        ) {
            return replaceVar(cache[lang][context][translationKey], variable)
        } else {
            return translationKey
        }
    }

    const replaceVar = (text, variables) => {
        let txt = text
        variables.forEach((variable) => {
            txt = txt.replace('{var}', variable)
        })
        return txt
    }

    return (
        <TranslationContext.Provider value={{
            translation,
            currentLanguage,
            setLanguage,
            availableLanguages: translationConfig.available_language
        }}>
            {children}
        </TranslationContext.Provider>
    );
}

export {TranslationContext, TranslationProvider};
